/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {ReactNode} from 'react';
import {WithTranslationProps} from 'react-i18next';
import IonContent from '@ion/dls/src/components/grid/IonContent';
import {GridLayoutSizes} from '@ion/dls/src/types/components';

// full-width gridLayoutSizes value used by current-theme pages that don't
// want IonContent's default centered/constrained grid margins ...
export const FULL_WIDTH_GRID_LAYOUT_SIZES: GridLayoutSizes = {xs: 12, md: 12};

// defines the props used by the local content component ...
export interface LayoutContentProps extends WithTranslationProps {
  initialized?: boolean;
  children?: ReactNode;
  grid?: boolean;
  backgroundColor?: string;
  id?: string;
  omit?: boolean;
  title?: string;
  gridLayoutSizes?: GridLayoutSizes;
  useExpandedWidth?: boolean;
}

/**
 * Defines the Content Wrapper Component which manages the rendering of the
 * content area of the Layout based on the initialization state and provided
 * props.
 *
 * ```typescript
 *
 *   import LayoutContent, {LayoutContentProps} from '@ion/applications/src/layout/LayoutContent';
 *   ...
 *   <LayoutContent initialized={pageInitialized} grid={grid}>
 *     {children}
 *   </LayoutContent>
 *
 * ```
 */
export const LayoutContent = ({
  initialized,
  gridLayoutSizes,
  useExpandedWidth,
  children,
  grid = true,
  id = 'layout-content'
}: LayoutContentProps) => {
  if (initialized) {
    if (grid) {
      return (
        <div id={id}>
          <IonContent gridLayoutSizes={gridLayoutSizes}
            useExpandedWidth={useExpandedWidth}>
            {children}
          </IonContent>
        </div>
      );
    }
    return <>{children}</>;
  }
  return null;
};
export default LayoutContent;
